import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import UploadModal from '../tc-ui/csv-upload/csv-upload-container';
import { updateTempConnectionsProps } from '../../stores/temp-connections/temp-connections-actions';
import ExampleCSVUpload from '../../../www/images/add-connections-ex-csv.png';
import R from 'ramda';

class CSVUploadModal extends Component {

  render() {
    const {
      updateProp,
      reset,
    } = this.props;

    return (
      <UploadModal
        open={this.props.open}
        onRequestClose={() => this.props.onRequestClose('uploadModal')}
        additFixErrorsFunc={() => reset()}
        showFailedSection
        onCompleteFunc={successfulRows => {
          updateProp({
            processed: true,
            allRecordsValid: true,
            allInvitationsProcessed: true,
            connections: successfulRows.map(record => R.merge(record, { recordValid: true })),
          });
          this.props.onRequestClose('uploadModal');
        }}
        dialogTitle={'Upload An Excel or CSV File'}
        note={
          <div>
            The CSV or Excel file must have the following layout: <b>Company Name (optional), Email (required), First Name (optional), Last Name (optional)</b>. Example format:
            <br/><br/>
            <img src={ExampleCSVUpload} width={500} />
          </div>
        }
        dropzoneText={'Drag and drop your CSV or Excel file here or click inside to choose a file from your computer'}
        headers={[
          {
            headerTitle: 'companyName',
            required: false,
          },
          {
            headerTitle: 'email',
            required: true,
          },
          {
            headerTitle: 'firstName',
            required: false,
          },
          {
            headerTitle: 'lastName',
            required: false,
          },
        ]}
      />
    );
  }
}

CSVUploadModal.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  updateProp: PropTypes.func,
  reset: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateTempConnectionsProps(...args)),
});

export default connect(null, mapDispatchToProps)(CSVUploadModal);



// WEBPACK FOOTER //
// ./src/app/components/temp-connections/csv-upload-modal.jsx